// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/arrow-big-up-dash.js';

import { paths } from '../generated/arrow-big-up-dash';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('arrow-big-up-dash', Original, paths);
